import React from 'react'
import { Imgix } from '@elements'

export const HeroThree = ({
  contentHeadline,
  contentWysiwyg,
  backgroundImage,
}) => {
  return (
    <section className="mt-8 bg-white sm:mt-10 md:mt-16 lg:mt-0">
      <div className="container flex flex-wrap">
        <div className="w-full ml-4 lg:w-5/12 sm:ml-16 md:ml-24 lg:ml-0 lg:flex lg:justify-center lg:flex-col">
          <h1 className="font-sans text-4xl font-bold leading-tight tracking-wider uppercase text-brand-red sm:text-5xl">
            {contentHeadline}
          </h1>
          <div
            className="max-w-sm mt-3 text-lg leading-normal text-gray-500 lg:max-w-lg sm:text-2xl lg:text-xl xl:text-2xl"
            dangerouslySetInnerHTML={{ __html: contentWysiwyg }}
          ></div>
        </div>
        <div className="w-full mt-8 lg:w-7/12">
          {backgroundImage && (
            <Imgix
              src={backgroundImage.mediaItemUrl}
              alt={backgroundImage.altText}
              className="w-full h-auto sm:w-4/5 sm:ml-auto md:w-3/4 lg:w-full"
            />
          )}
        </div>
      </div>
    </section>
  )
}
